import config from "../../../../../../config/common";
import { getSearchMetadata } from "../../diagnostics/selectors";
import { selectSearchState } from "../../selectors/shared";
import { getIsNewSearch } from "../../ui/selectors";

const emptyObject = {};

export const selectSearchQueryDomain = state => {
  const search = selectSearchState(state);

  return {
    query: search.query ?? emptyObject,
    searchTerm: search.searchTerm ?? "",
    pageSize: search.pageSize,
    additionalQueryParams: search.additionalQueryParams ?? emptyObject,
    personalisationParams: search.personalisationParams ?? emptyObject
  };
};

export const getPageSize = state =>
  state.search?.pageSize ?? config.api.product.search.pageSize;

export const getSearchTerm = ({ search: { searchTerm } }) => searchTerm;

export const getAdditionalQueryParams = ({
  search: { additionalQueryParams }
}) => additionalQueryParams;

export const getPersonalisationParams = ({
  search: { personalisationParams }
}) => personalisationParams;

export const getSort = state =>
  state.search.selectedSort &&
  Object.keys(state.search.selectedSort).includes("value")
    ? state.search.selectedSort.value
    : state.search.query && state.search.query.sort;

export const isExactMatch = state => {
  const { isPartial, isSpellcheck } = getSearchMetadata(state);

  return isPartial === false && isSpellcheck === false;
};

export const getSearchPassesName = state => {
  const searchPass = getSearchMetadata(state).searchPass || [];

  return searchPass.map(({ name }) => name.toLowerCase());
};

export const getSuggestTerms = state =>
  getSearchMetadata(state).alternateSearchTerms;

export { getIsNewSearch };
